/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-31 14:23:29
 * @LastEditors: linxi
 * @LastEditTime: 2021-06-24 19:16:41
 */
import { api } from '../app/applicationSlice'
import { API_PREFIX } from './constant'
import { Request } from './request'
export interface AddtionDrugParams {
  current?: number
  size?: number
  tenantMaintainId?: number
  materialsCategory?: number
  name?: string
}

export interface ModalDurgParams {
  current?: number
  maintainCategory?: number
  materialsCategory?: number
  name?: string
  size?: number
  storehouseId?: number
  tenantId?: number
  deadlineStart?: string
  deadlineEnd?: string
}

export interface SaveAllDurgBody {
  maintainCategory?: number
  maintainMeasure?: string
  maintainQuality?: number
  maintainResult?: number
  materialsCategory?: number
  name?: string
  status?: number
  storehouseId?: number
  tenantMaintainId?: number
}

export function getAddtionDrugPage(params: AddtionDrugParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintainitem/page`,
    method: 'GET',
    params,
  }
}

export function getAddtionDrugData(params: AddtionDrugParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintainitem/list`,
    method: 'GET',
    params,
  }
}

export function getModalDurgData(params: ModalDurgParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryledger/maintainlist`,
    method: 'GET',
    params,
  }
}

export function saveDurgbatch(ids: Array<any>): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintainitem/submit`,
    method: 'POST',
    body: ids,
  }
}

export function removeDurg(ids: string): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintainitem/remove`,
    method: 'POST',
    params: {
      ids,
    },
  }
}

export function saveAllDurg(body: SaveAllDurgBody): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintainitem/addbatch`,
    method: 'POST',
    body,
  }
}

export function getExportKCYHExcel(params: AddtionDrugParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintainitem/list/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

export interface MaintainCustomBody {
  id?: number | string
  content?: string
  type?: number
}

// 养护自定义项单个保存（0 养护措施 / 1 质量状况 / 2 养护结果）
export function saveMaintainCustom(body: MaintainCustomBody): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintain/custom/save`,
    method: 'POST',
    body,
  }
}

// 养护自定义项删除
export function removeMaintainCustom(params: { id?: number | string }): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintain/custom/remove`,
    method: 'GET',
    params,
  }
}

// 养护自定义项列表（不传 type 获取全部，返回按 type 分组）
export function getMaintainCustomList(): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintain/custom/list`,
    method: 'GET',
  }
}
